// extracted by mini-css-extract-plugin
export default {"event":"calendarEvent_event__w6WYq"};